import React, { Fragment } from "react";
import Icon from "../../../form/Icon";
import SelectorGrid from "../../../form/SelectorGrid/SelectorGrid";
import { loadComponent } from "../../../../utils/components";
import { list } from "../../../../utils/array";
import DataGrid from "../../../form/SelectorGrid/DataGrid";
import TextInput from "src/components/form/TextInput";

class Item extends React.Component<any, any> {
    render() {
        let filename = this.props.value.split('/').pop();
        let ext = filename.split('.').pop();
        if ((this.props.value || "").toLowerCase().match(/.(jpg|jpeg|png|gif)$/i)) {
            return <Fragment><a href={this.props.value} target="_blank"><img src={this.props.value} alt={filename} style={{ maxWidth: '50px', maxHeight: '50px' }} /></a> </Fragment>
        }
        return (
            <Fragment><a href={this.props.value} target="_blank"><Icon lib="far" name={"file-" + ext} /> {filename}</a> </Fragment>
        );
    }
}

const VoteInputFormatter = ({ value, row, editItems }) => {
    return <TextInput
        value={value?.score}
        type="number"
        label={false}
        min={0}
        max={10}
        disabled={!!value?.user?.id}
        error={value?.score == 0 ? "Nem lehet 0" : null}
        placeholder="1-10"
        saveChanges={(field, value) => {
            editItems({ [row.id]: { score: value } });
        }}
    />

};

class AnswerList extends React.Component<any, any> {

    state: any = {
        numberOfAnswers: null,
    }

    checkNumberOfSavedAnswers(answerList: { [key: string]: any }) {
        let numberOfSaved = 0;
        Object.values(answerList).forEach(item => {
            if ("id" in item) {
                numberOfSaved++;
            }
        });
        return numberOfSaved;
    }


    componentDidUpdate(prevProps: any) {
        if (this.checkNumberOfSavedAnswers(this.props.scoreList) !== this.checkNumberOfSavedAnswers(prevProps.scoreList)) {
            this.list?.refreshBackground();
        }
    }

    render() {
        let questions = this.props.questions?.items || [];
        if (!questions.length) return null;
        let columns = questions.reduce((columns: object, poll: { [key: string]: any }) => (poll.type_value + "" === "5" ? { ...columns } : {
            ...columns, ["poll_" + poll.id]: {
                props: {
                    width: questions.length > 1 ? questions.length : 10,
                    header: poll.title,
                    sortable: true,
                    filterable: true,
                    formatter: ({ value, row }) => {
                        switch (poll.type_value + "") {
                            case "6":
                                if (Array.isArray(value)) {
                                    return value.map((value, idx) => <Item
                                        key={idx} {...(value instanceof Object ? (value || {}) : { value })} />);
                                } else {
                                    return <a href={value} target="_blank">{value}</a>;
                                }
                            default:
                                return value || "";
                        }
                    }
                }
            }
        }), {
            // "id": {
            //     props: {
            //         width: 1,
            //         header: "Kód",
            //         order: "ASC",
            //         sortable: true,
            //         filterable: true,
            //     }
            // },
            "score": {
                props: {
                    width: 1,
                    header: "Pontszámok",
                    formatter: VoteInputFormatter
                }
            }
        }
        );
        const filter = list(this.props.filter, { field: "quiz_id", value: this.props.quiz_id });
        const style = {};
        if (this.props.label === false) {
            style.display = "none";
        }
        return (
            <div className="row form-row">
                <div className="col-sm-12">
                    <div className="form-group">
                        {this.props.label !== false && <label htmlFor={this.props.name} className="control-label" style={style}>{this.props.label}</label>}
                        <DataGrid
                            ref={(list) => this.list = list}
                            component="QuizAnswer"
                            filter={filter}
                            fields={columns}
                            onLoadCompleted={async (data) => {
                                this.props.setAnswers(data.fullcount, () => {
                                    data.items = data.items.map((item) => {
                                        item.score = this.props.scoreList[item.id];
                                        return item;
                                    });
                                    return data;
                                })
                            }}
                            editItems={(items) => {
                                let scoreList = { ...this.props.scoreList };
                                items.forEach((item, id) => {
                                    scoreList[id] = item;
                                });
                                this.props.setScoreList(scoreList, () => {
                                    this.list?.refreshBackground();
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default class QuizAnswerVoteField extends React.Component<{ quiz_id: any, filter?: any, label?: any | false | string } & React.ComponentPropsWithoutRef<any>, any> {

    componentDidMount() {
        this.loadPolls();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.quiz_id !== prevProps.quiz_id) {
            this.loadPolls();
        }
    }

    loadPolls = () => {
        this.pollRequest && this.pollRequest.abort();
        this.pollRequest = loadComponent("componentlist", {
            component: "Poll",
            filter: { field: "quiz", value: this.props.quiz_id },
            itemsperpage: 0
        });
        this.pollRequest.then((data) => {
            this.setState({ data });
        })
    }

    render() {
        return (
            <AnswerList {...this.props} questions={this.state?.data || {}} />
        );
    }
}